import { ApiService } from "@/api";

export const updateTelpIntvSampleStatus = (sampleId: string, status: string) => {
  return ApiService.baseAction(
    `sample-telephone-interview/status/${sampleId}`,
    {
      data: {
        status,
      },
    },
    "post"
  );
};
